<div class="logo"
  [style.width]="width ? (width + 'px') : null"
  [ngClass]="{ 'dark-logo': type === 'dark', 'light-logo': type === 'light', 'logo-icon': type === 'icon' }"
></div>
